<template>
  <div>
    <div class="payment-page" :style="show ? 'background: #2b2728' : ''">
      <div style="width: 100%" v-if="show">
        <img src="@/assets/top-logo@2x.png" style="width: 100%" alt="" />
      </div>
      <div class="titleMaxBox" v-if="show">
        <div style="display: flex">
          <p
            style="display: flex; align-items: center; justify-content: center"
          >
            <span
              v-show="form.randomAmount"
              style="font-size: 30px; color: #fff"
              >Rs {{ form.randomAmount }}</span
            >
            <van-loading
              type="spinner"
              v-show="!form.randomAmount"
              style="color: #fff"
              vertical
            ></van-loading>
          </p>
        </div>
        <div class="timer">
          <van-count-down
            :style="
              time == '9999'
                ? 'color: #2b2728;font-size: 16px;'
                : 'font-size: 16px;line-height: 25px;height: 25px;color: #fff;font-weight:bold'
            "
            format="mm:ss"
            :time="time"
            @finish="onFinish"
          />
        </div>
      </div>
      <div style="padding: 1.8rem" v-if="show">
        <div class="qcBox" style="position: relative">
          <div class="qcBoxTxt">
            <p style="font-weight: bold">
              Step 1-Transfer INR {{ form.randomAmount }}
            </p>
            <p>
              Scan the UPl QR Code or select one of the apps below to continue
              your deposit
            </p>
          </div>
          <van-image
            width="100%"
            height="100%"
            fit="fill"
            :src="formattedQrCode"
            style="margin-bottom: 12px"
            v-if="showQr == true"
          />
          <img
            src="@/assets/boli@3x.png"
            alt=""
            style="width: 100%; height: 100%; margin-bottom: 4px"
            v-if="showQr == false"
          />

          <div
            class="saveQR"
            @click="QRCodeBtnsFun"
            :style="
              !saveQRferFlag
                ? 'background: #e7e7e7;color:#999999;border: 1px solid #999999;'
                : 'color:#999999;border: 1px solid #999999;'
            "
            v-debounce="QRCodeBtnsFun"
            v-if="showQr == true"
          >
            Save QR Code
          </div>
          <div class="saveQR" v-if="showQr == false" @click="payOne(1)">
            Show QR code
          </div>

          <div class="showOneSearchTwos" style="margin-top: 20px">
            <p style="font-size: 14px">{{ form.upiAccountHide }}</p>

            <div class="showOneSearchTwosCopy">
              <span style="font-weight: bold" @click="copyText(1)">Copy</span>
              <img
                src="@/assets/copy -i@2x.png"
                alt=""
                style="width: 18px; height: 18px"
                @click="copyText(1)"
              />
            </div>
          </div>
        </div>
        <div class="newUPI">
          <div class="qcBoxTxt">
            <p style="font-weight: bold">Step 2 -Submit UTR No</p>
            <p>Enter UTR/UPl reference lD</p>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              margin-bottom: 16px;
              border-radius: 10px;
            "
          >
            <van-field
              style="
                flex: 1;
                height: 44px !important;
                line-height: 44px;
                padding: 0 14px;
                border-radius: 10px;
                background: #eeeeee;
                font-size: 14px;
              "
              v-model="utrValue"
              placeholder="UTR(UPI Ref.ID)"
            />
            <div
              class="submitUTRCss"
              v-if="showNum != 9"
              v-debounce="submitPayment"
              :style="!submitUTRFlag ? 'background: #e7e7e7' : ''"
            >
              Submit
            </div>
          </div>
        </div>
        <div class="txtB">
          <img
            src="@/assets/jinggao@2x.png"
            alt=""
            style="width: 18px; height: 18px"
          />
          <p>
            <span>Please</span> confirm that the above account information is
            correct and use this account to make the payment, otherwise the
            payment will not be completed.
          </p>
        </div>
      </div>

      <div v-else>
        <div class="sBox" v-if="status == 'wait'">
          <div v-if="orderStatus == ''" class="sBox">
            <div class="circle">
              <div class="dots">
                <div
                  v-for="n in 8"
                  :key="n"
                  class="dot"
                  :style="getDotStyle(n)"
                ></div>
              </div>
              <div class="countdown">
                {{ countdown }}
              </div>
            </div>
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: 400;
                text-align: center;
                font-size: 15px;
                color: #333333;
              "
            >
              UTR submitted successfully and <br />
              is being confirmed
            </p>
          </div>
          <div v-if="orderStatus == 1" class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/success@2x.png')"
            />
            <p class="sp">Your payment is successful!</p>
          </div>
          <div v-else class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/时间@2x.png')"
            />
            <p class="sp">
              The payment result may be delayed,<br />
              we will process it within 10 minutes
            </p>
          </div>
        </div>
      </div>
      <div class="sBox" v-if="status == 'timeout'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">Payment timed out, please try again</p>
      </div>

      <div class="sBox" v-if="status == 'prompt'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          Payment submission is successful, please wait patiently for the
          payment result
        </p>
      </div>

      <div class="sBox" v-if="status == 'promptTwo'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          {{ h5PayOrderQueryMsg }}
        </p>
      </div>

      <div class="sBox" v-if="status == 'err'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">{{ msg }}</p>
      </div>
    </div>

    <div class="dBox" v-if="dialogFlag">
      <div class="nos" @click="noFlase">X</div>
      <div>
        <p>MobiKwik</p>
        <img src="@/assets/to1.jpg" alt="" />
        <p>Freecharge</p>
        <img src="@/assets/to2.jpg" alt="" />
        <p>Gpay</p>
        <img src="@/assets/to3.jpg" alt="" />
        <p>PayTM</p>
        <img src="@/assets/to4.jpg" alt="" />
        <p>PhonePe</p>
        <img src="@/assets/to5.jpg" alt="" />
      </div>
    </div>

    <div class="loadingBox" v-if="loadingFlag">
      <div
        style="
          margin-top: 50vh;
          transform: translate(-50%, -50%);
          width: 120px;
          height: 120px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 14px;
          margin-left: 50vw;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <!-- 旋转类型+文字 -->
        <van-loading type="spinner" style="color: #fff" vertical
          >loading...</van-loading
        >
      </div>
    </div>
    <van-action-sheet v-model="tosUpiFlag" title=" " :z-index="100">
      <div class="contentTwo">
        <p style="color: #558cf3">
          Use {{ payFlag == 1 ? "Mobile" : "PhonePe" }} Scan code to pay
        </p>

        <div
          style="
            width: 146px;
            height: 146px;
            background: #fff;
            margin: 0 auto;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            margin-top: 28px;
          "
        >
          <van-image
            width="94pt"
            height="94pt"
            fit="fill"
            :src="formattedQrCode"
          />
        </div>

        <p
          style="font-size: 44px; color: #f90516; margin-top: 17px"
          v-if="payFlag == 1"
        >
          00:{{ formattedTime }}
        </p>

        <div
          class="saveQR"
          @click="QRCodeBtnsFun"
          :style="
            !saveQRferFlag
              ? 'background: #e7e7e7;color:#999999;border: 1px solid #999999;margin-top: 17px'
              : 'color:#999999;border: 1px solid #999999;margin-top: 17px'
          "
          v-debounce="QRCodeBtnsFun"
          v-if="payFlag == 2"
        >
          save QR Code
        </div>

        <div class="utrInput">
          <p style="color: #999999; font-size: 12px; margin-left: 14px">UTR</p>
          <van-field
            style="flex: 1; height: 44px; line-height: 44px; padding: 0 14px"
            v-model="utrValue"
            placeholder=""
          />
        </div>

        <p style="line-height: 20px; margin-bottom: 18px" v-if="payFlag == 1">
          If the payment is not successful within 60 seconds, please fill in the
          transaction UTR
        </p>
        <p style="line-height: 20px; margin-bottom: 18px" v-if="payFlag == 2">
          Please fill in the UTR after scanning the QR code to pay, otherwise
          the order may fail
        </p>
        <p
          class="test1"
          style="color: #558cf3; font-size: 14px; text-decoration: auto"
          @click="noFlase"
        >
          How to find utr?
        </p>

        <div
          class="btnFun"
          v-if="showNum != 9"
          v-debounce="submitPayment"
          :style="
            !submitUTRFlag
              ? 'background: #e7e7e7'
              : 'background: #558cf3; color: #fff'
          "
        >
          Submit
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  h5CashRegisterGetUpiV2,
  h5PayOrderQuery,
  h5CheckOutClickV2,
  h5CheckOutUtrSubmit,
  h5OrderBuriedPointCreate,
} from "@/api";
import { Button, Dialog } from "vant";
import Vue from "vue";
Vue.use(Button);
import { Icon } from "vant";
Vue.use(Icon);
import { Field } from "vant";
Vue.use(Field);
import { CountDown } from "vant";
Vue.use(CountDown);
import { Image as VanImage } from "vant";
Vue.use(VanImage);
import { Toast } from "vant";
Vue.use(Toast);
import { ActionSheet } from "vant";
Vue.use(ActionSheet);
import { Loading } from "vant";
Vue.use(Loading);

import Clipboard from "clipboard";

export default {
  data() {
    return {
      time: 9999,
      status: "默认",
      upiId: "",
      headers: {
        "X-Plat-Order-Id": this.$route.query.orderId,
        "X-Sign": this.$route.query.sign, // 使用组件中的动态值
      },
      form: {},
      show: true,
      countdown: 10,
      interval: null,
      intervalStatus: null,
      orderStatus: "",

      dialogFlag: false,
      msg: "",

      showOne: false,

      utrValue: "",

      showNum: 1,

      url: "",

      statusFlag: false,

      loadingFlag: false,

      btnFlag: false,

      QRcodeFlag: true,
      manualTransferFlag: true,
      saveQRferFlag: true,
      submitUTRFlag: true,
      copyUpiIdFlag: true,

      h5PayOrderQueryMsg: "",

      upiAccount: "",
      showQr: false,

      // 跳转返回弹框
      tosUpiFlag: false,

      countdownTwo: 60,
      isRunning: false,
      timer: null,
      payFlag: 1,

      clipboard: null,
      isDataReady: false, // 新增状态标记

      maxRetries: 1,
      statusT: "",

      randomAmount: "",

      toJumpUrl: "",
    };
  },
  methods: {
    noFlase() {
      this.showOne = false;
      this.dialogFlag = !this.dialogFlag;
      this.tosUpiFlag = false;
    },

    getDotStyle(index) {
      const angle = index * 45 * (Math.PI / 180); // 每个点之间的角度
      const radius = 30; // 半径
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      return {
        transform: `translate(${x}px, ${y}px)`,
        animation: `dot-animation 1.4s ease-in-out infinite ${index * 0.1}s`,
      };
    },
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    async getStatus() {
      const res = await h5PayOrderQuery(
        {
          platOrderId: this.$route.query.orderId,
        },
        {
          "X-Plat-Order-Id": this.$route.query.orderId,
          "X-Sign": this.$route.query.sign,
        }
      );

      if (res.status != 2) {
        clearInterval(this.interval);
        clearInterval(this.intervalStatus);
        this.orderStatus = res.status;
      }

      if (res.jumpUrl != "") {
        this.toJumpUrl = res.jumpUrl;
      }
  console.log(res.status, this.countdown);
  
      // 订单失败处理
      if (res.status == 3) {
        this.show = false;
        this.status = "err";
        this.msg = "Payment failed";
        return;
      }

      // 订单成功处理
      if (res.status == 1) {
        if (this.toJumpUrl != "") {
          window.open(this.toJumpUrl, "_blank");
        }

        this.show = false;
        this.status = "promptTwo";
        this.h5PayOrderQueryMsg = "Order successful";
        return;
      }

      if (res.status == 2 && this.countdown == 0) {
        this.orderStatus = 8;
      }
    },
    async getInfo() {
      const res = await h5CashRegisterGetUpiV2(
        {
          platOrderId: this.$route.query.orderId,
        },
        this.headers
      );

      if (res.status == "635") {
        if (this.maxRetries < 3) {
          this.loadingFlag = true;
          this.maxRetries++;
          setTimeout(async () => {
            return await this.getInfo();
          }, 1500);
          return;
        }
        this.loadingFlag = false;
        this.statusT = 635;
        this.show = false;
        this.status = "err";
        this.msg = "Please refresh the page and try again.";
        return;
      }

      // 链接已经被调起
      if (res.status == 3 && this.show != false) {
        Dialog.confirm({
          title: "prompt",
          message: "Have you completed the payment?",
          confirmButtonText: "Not paid yet", //取消按钮
          cancelButtonText: "Paid", //确定按钮
        })
          .then(() => {
            if (this.toJumpUrl != "") {
              window.open(this.toJumpUrl, "_blank");
            }
          })
          .catch(() => {
            this.show = false;
            this.status = "prompt";
          });
      }

      // 异常处理
      if (res.status == 600 || res.status == 620) {
        this.show = false;
        this.status = "err";
        this.msg = res.message;
        return;
      }

      this.form = res;

      this.upiAccount = res.upiAccount;
      this.h5OrderBuriedPointCreateFun(3);

      this.calculateTimeDifference(res.expireTime);

      if (!this.intervalStatus) {
        this.intervalStatus = setInterval(() => {
          if (this.statusT != 635) {
            this.getStatus();
            if (this.countdown <= 0) {
              clearInterval(this.intervalStatus);
            }
          }
        }, 3000);
      }
    },

    onFinish() {
      this.show = false;
      this.status = "timeout";
      clearInterval(this.intervalStatus);
    },

    calculateTimeDifference(params) {
      // 获取当前印度时间的 Date 对象
      const currentTime = (() => {
        const indianTimeString = new Date().toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        });
        return new Date(indianTimeString);
      })();

      // 订单有效时间
      const expireTime = new Date(params.replace(" ", "T"));

      // 计算时间差，单位为毫秒
      const timeDifference = expireTime - currentTime;

      // 将结果赋值给 time
      this.time = timeDifference;
    },

    async submitPayment() {
      if (!this.utrValue) {
        Toast.fail("Please enter the UTR.");
        return;
      }
      // if (this.utrValue.length < 10 || this.utrValue.length > 18) {
      //   this.$toast.fail('The length must be between 10-18 digits')
      //   return
      // }
      if (!/^\d{12}$/.test(this.utrValue)) {
        this.$toast.fail(
          "UTR format error:UTR is a 12-digit combination, please check carefully"
        );
        return;
      }

      this.h5OrderBuriedPointCreateFun(21);

      if (this.submitUTRFlag == false) {
        return false;
      }

      this.submitUTRFlag = false;

      h5CheckOutUtrSubmit(
        {
          platOrderId: this.$route.query.orderId,
          utr: this.utrValue,
        },
        this.headers
      )
        .then((res) => {
          this.show = false;
          if (this.toJumpUrl != "") {
            window.open(this.toJumpUrl, "_blank");
          }

          this.status = "wait";
          this.startCountdown();

          this.submitUTRFlag = true;

          this.tosUpiFlag = false;
        })
        .catch((err) => {
          this.submitUTRFlag = true;
          this.tosUpiFlag = false;
          Toast.fail(err.message);
        });
    },
    payOne(num, url) {
      this.utrValue = "";
      if (!this.btnFlag) {
        return false;
      }

      if (num != 3) {
        h5CheckOutClickV2(
          {
            platOrderId: this.$route.query.orderId,
            payMethod: num == 1 ? 2 : num == 9 ? 3 : 1,
          },
          this.headers
        ).then((res) => {
          // if (res.status == 200) {
          // if (num == 1) {
          //   this.showNum = 2
          //   this.showOne = true
          // } else {
          //   if (num == 2) {
          //     this.showNum = 9
          //     this.showOne = true
          //   }
          // }
          // }
        });
      }

      if (url) {
        this.url = url;
      }
      if (num == 9) {
        this.h5OrderBuriedPointCreateFun(10);
        window.open(this.url, "_blank");
        this.loadingFlag = true;
        // 设置超时检测（移动端通常在1000ms内会跳转成功）
        setTimeout(() => {
          // 如果500ms后页面仍然存在，则认为跳转失败
          this.loadingFlag = false;

          this.payFlag = 1;
          this.tosUpiFlag = true;
          this.start();
        }, 1000);
        return;
      }
      if (num == 3) {
        this.h5OrderBuriedPointCreateFun(13);
        this.showNum = 1;
        this.showOne = true;
        this.manualTransferFlag = false;
      } else {
        if (num == 1) {
          this.showQr = true;

          this.h5OrderBuriedPointCreateFun(11);
          this.showNum = 2;
          this.showOne = true;
          this.QRcodeFlag = false;
        } else {
          if (num == 2) {
            this.showNum = 9;
            this.showOne = true;
          }
        }
      }
    },

    setRootFontSize() {
      const baseSize = 16; // 基准字体大小
      const scale = document.documentElement.clientWidth / 375; // 375 为设计稿宽度
      document.documentElement.style.fontSize =
        baseSize * Math.min(scale, 2) + "px"; // 限制缩放倍数
    },

    // 保存图片
    QRCodeBtnsFun() {
      this.payOne(10);
      const image = new Image();
      image.crossOrigin = "Anonymous"; // 允许跨域
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0);

        canvas.toBlob((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "saved_image.jpg"; // 设置下载的文件名
          link.click();

          // 释放内存
          URL.revokeObjectURL(link.href);
        }, "image/jpeg");
      };
      image.src = this.formattedQrCode;

      this.h5OrderBuriedPointCreateFun(12);
    },

    h5OrderBuriedPointCreateFun(num) {
      if (num == 3) {
        this.btnFlag = true;
      }

      if (num == 11 && this.QRcodeFlag == false) {
        return false;
      } else if (num == 13 && this.manualTransferFlag == false) {
        return false;
      } else if (num == 12 && this.saveQRferFlag == false) {
        return false;
      }

      h5OrderBuriedPointCreate(
        {
          platOrderId: this.$route.query.orderId,
          operationType: num,
        },
        this.headers
      ).then((res) => {
        // console.log(res, num)

        if (num == 11) {
          // 点击qrcode弹框打开按钮时候
          this.QRcodeFlag = true;
        } else if (num == 13) {
          // 点击Manual Transfer弹框打开按钮时候
          this.manualTransferFlag = true;
        } else if (num == 12) {
          // 点击保存二维码按钮时候
          this.saveQRferFlag = true;
        }
      });
    },

    // 复制文本
    async copyText(num) {
      // 如果数据未准备好，先获取数据
      if (num == 1) {
        await this.fetchUpiAccount();
      }

      setTimeout(() => {
        // Create and append the fake button first
        const fakeBtn = document.createElement("button");
        fakeBtn.className = num == 1 ? "showOneCopy" : "iconCopy";
        fakeBtn.style.display = "none";
        document.body.appendChild(fakeBtn);

        // Initialize Clipboard.js after the button exists in DOM
        const clipboard = new Clipboard(fakeBtn, {
          text: () =>
            num == 1
              ? this.upiAccount
              : num == 2
              ? this.form.randomAmount.toFixed(2)
              : this.randomAmount,
        });

        clipboard.on("success", (e) => {
          this.$toast.success("Replicating Success!");
          e.clearSelection();
          clipboard.destroy();
          document.body.removeChild(fakeBtn);
        });

        clipboard.on("error", (e) => {
          this.$toast.error("Copy failed!");
          clipboard.destroy();
          document.body.removeChild(fakeBtn);
        });

        // Trigger click after everything is set up
        fakeBtn.click();
      }, 500);
    },

    async fetchUpiAccount() {
      if (!this.copyUpiIdFlag) return false;

      this.copyUpiIdFlag = false;
      try {
        const res = await h5CheckOutClickV2(
          { platOrderId: this.$route.query.orderId, payMethod: 1 },
          this.headers
        );

        this.upiAccount = res.upiAccount;
        this.randomAmount = res.randomAmount;
        this.isDataReady = true;

        this.h5OrderBuriedPointCreateFun(14);
        return true;
      } catch (err) {
        // Toast.fail('请求过于频繁')
        return false;
      } finally {
        this.copyUpiIdFlag = true;
      }
    },

    // 开始倒计时
    start() {
      if (this.isRunning || this.countdownTwo <= 0) return;

      this.isRunning = true;
      this.timer = setInterval(() => {
        this.countdownTwo--;

        if (this.countdownTwo <= 0) {
          this.pause();
        }
      }, 1000);
    },
    // 暂停倒计时
    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.isRunning = false;
        this.timer = null;
      }
    },
    // PhonePe支付
    payPhonePe() {
      this.payFlag = 2;
      this.tosUpiFlag = true;

      h5CheckOutClickV2(
        {
          platOrderId: this.$route.query.orderId,
          payMethod: 2,
        },
        this.headers
      ).then((res) => {});
    },
  },
  computed: {
    formattedQrCode() {
      // 动态拼接前缀
      return `data:image/png;base64,${this.form.qrCode}`;
    },
    // 格式化时间，小于10补零
    formattedTime() {
      return this.countdownTwo < 10
        ? `0${this.countdownTwo}`
        : this.countdownTwo.toString();
    },
  },
  created() {
    this.h5OrderBuriedPointCreateFun(2);
  },
  mounted() {
    this.getInfo();

    this.setRootFontSize();

    window.addEventListener("resize", this.setRootFontSize);
  },
  beforeDestroy() {
    var _this = this;

    // 结束时候调取的，但无法正常实现
    window.addEventListener("beforeunload", () => {
      _this.h5OrderBuriedPointCreateFun(30);
    });

    window.removeEventListener("resize", _this.setRootFontSize);

    // 销毁 Clipboard 实例
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  },

  destroyed() {},
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.payment-page {
  min-height: 100vh;
  background: #e2f2fd;
}

.topT {
  text-align: center;
  margin-bottom: 25px;
  margin-top: 23px;
}

.topT > div:nth-child(1) {
  font-size: 18px;
  align-items: center;
  color: #fff;
}

.moneyBox {
  width: 100%;
  text-align: center;
}

.moneyBox p:nth-child(1),
.orderAmountT {
  font-size: 36pt;
  color: #fff;
  margin-bottom: 14px;
}

.payBox {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #a6d6ef;
  border-radius: 10px;
  margin-bottom: 10px;
  align-items: center;
}

.payBoxMIN {
  display: flex;
  justify-content: space-between;
}

.payBox div {
  display: flex;
  align-items: center;
}

.img1 {
  width: 30px;
  height: 30px;
  margin-right: 9px;
}
.img2 {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  margin-right: 2px;
}

.toS {
  height: 12px;
}

.payBtn {
  width: 60px;
  height: 24px;
  font-size: 0.625rem;
  background: #2a50ba;
  border-radius: 12px;
  color: #fff;
  text-align: center;
  line-height: 24px;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}

.txtBox1 {
  margin-top: 24pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
  color: #fc4877;
}

.txtBox2 {
  margin-top: 14pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
}

.content {
  padding: 2rem 26px 60px;
}

.contentTwo {
  padding: 2rem 15px 60px;
  background: #f0f0f0;
  text-align: center;
}

.contentTwo > p {
  font-size: 14px;
}

.showOneTitle {
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.showOneSearch {
  display: flex;
  margin-bottom: 1rem;
}

.showOneCopy {
  width: 4rem;
  background: #2a50ba;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border-radius: 5px;
}

.showOneTxt {
  font-size: 12px;
  color: #ff9b00 !important;
  margin-top: 12px;
  margin-bottom: 1.3rem;
  line-height: 16px;
  font-style: italic;
}

.showOneSearchLabel {
  display: flex;
}

.showOneSearchLabel p:nth-child(1) {
  color: #ff0000;
  margin-top: 6.5px;
  margin-left: 6.5px;
}
.showOneSearchLabel p:nth-child(2) {
  font-size: 1rem;
  margin-left: 4px;
}

.btnFun {
  width: 100%;
  background: #cccccc;
  margin: 20px auto 0;
  height: 50px;
  line-height: 50px;
  color: #666666;
  font-size: 14px;
  text-align: center;
  border-radius: 10px;
  /* font-weight: bold; */
}

.qrCodeImgs {
  text-align: center;
}

.qrCodeImgs p {
  font-size: 1rem;
  margin-bottom: 14px;
}

.sBox {
  height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sp {
  margin-top: 20px;
  font-family: Source Sans Variable;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
}
.circle {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dots {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: rotate 2.4s infinite linear;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  border-radius: 50%;
  position: absolute;
}

.countdown {
  position: absolute;
  font-size: 24px;
  color: red;
  font-weight: bold;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot-animation {
  0% {
    opacity: 0.3;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

.titleMaxBox {
  width: 100vw;
  background: #2b2728;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 15px 0 0;
  flex-direction: column;
}

.qcBox {
  border-radius: 5px;
  width: 100%;
  text-align: center;
  margin-bottom: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #373737;
  border-radius: 15px;
  padding: 20px 30px 30px;
}

.qcBox img {
  width: 100%;
}

.qcBoxTxt {
  margin-bottom: 16px;
}

.qcBoxTxt p {
  font-size: 12px;
  color: #fff;
  margin-top: 10px;
  text-align: left;
}

.qcBoxTwo {
  border-radius: 5px;
  width: 100%;
  text-align: center;
  margin-bottom: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #373737;
  border-radius: 15px;
}

.QRCodeBtns {
  width: 145px;
  height: 29px;
  text-align: center;
  line-height: 29px;
  border: 1px solid #cacaca;
  border-radius: 3px;
  margin: auto;
  color: #333333;
  margin-top: 20px;
  font-size: 12px;
}

.payBoxB {
  margin-top: 9px;
  color: #ff9b00 !important;
  line-height: 16px;
  font-size: 10px !important;
}
.btnBox div {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
  margin-bottom: 10px;
}
.btnBox div:nth-child(1) {
  text-align: left;
  padding-left: 20px;
  border-radius: 10px;
  background: #f3f3f6;
  color: #a1a1a1;
  margin-bottom: 30px;
}
.btnBox div:nth-child(2) {
  color: #f3f3f6;
  background: #2a50ba;
  font-weight: bold;
}

.txtBoxMax {
  font-size: 14px;
  margin-top: 16px;
  font-weight: bold;
}

.txtBoxMax div {
  display: flex;
}
.txtBoxMax div p {
  line-height: 20px;
  color: #666666;
  margin-bottom: 10px;
  font-weight: 200 !important;
}

.dBox {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20pt;
  width: 100vw; /* 固定宽度 */
  height: 100vh; /* 固定高度 */
  overflow: auto; /* 自动显示滚动条 */
  z-index: 999999999999999999999999999999999999999999999999999999;
}

.dBox img {
  width: 100%;
}

.nos {
  position: fixed;
  top: 0;
  right: 0;
  width: 36pt;
  height: 36pt;
  border-radius: 18pt;
  text-align: center;
  line-height: 40pt;
  background: #fff;
  font-size: 22px;
}

.dBox p {
  margin: 20px 0;
  font-size: 22px;
}

.topTMax {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  background: #fff;
  padding: 14px;
  border-radius: 10px;
}

.topTMax > div:nth-child(1) {
  font-size: 16px;
  align-items: center;
  color: #333333;
  font-weight: bold;
}

.timer {
  border-radius: 20px;
  color: #df415d;
  text-align: center;
}

.mSy {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}

.mSyTwo {
  font-size: 16px;
  display: block;
  text-align: center;
}

.payTxt {
  background: #f4f9fe;
  color: #5593f3;
  padding: 14px 20px;
  width: 100%;
  margin-bottom: 28px;
}

.test1 {
  color: #da2f2f;
  margin-bottom: 12px;
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.saveQR {
  display: inline-block;
  color: #558cf3;
  border: 1px solid #558cf3;
  border-radius: 22px;
  padding: 0px 20px;
  font-size: 14px !important;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
}

.mainBox {
  background: #b9e2fd;
  border-radius: 10px;
  padding: 14px 10px 0px;
  margin-top: 16px;
  border: 1px solid #aad7f0;
}

.payBoxTips {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start !important;
  transform: translateY(4px);
}

.payBoxTips p:nth-child(1) {
  color: #2f1f50;
  font-size: 14px;
  font-weight: bold;
  transform: translateY(-3px);
  font-family: SourceSansRoman-Bold;
}
.payBoxTips p:nth-child(2) {
  color: #999999;
  font-size: 9px;
  transform: translateY(3px);
}

.payBtnBox {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end !important;
}

.payBtnBox p {
  color: #2a50ba;

  font-size: 0.625rem;
}
.payBtnBox span {
  font-weight: bold;
}

.payTMS {
  text-align: center;
  margin-top: 20px;
}
.payTMS img {
  height: 21px;
}

.txtTips {
  background: #fff;
  border-radius: 10px;
  padding: 0px 14px;
  margin-top: 10px;
  font-weight: bold;
  border: 1px solid #cacaca;
}

.txtTips > p {
  color: #111111;
  font-size: 14px;
}

.txtTips > p span {
  display: inline-block;
  background: #848383;
  width: 4px;
  height: 16px;
}

.showOneSearchLabelNews {
  display: flex;
  margin-bottom: 12px;
}
.showOneSearchLabelNews p:nth-child(1) {
  font-size: 14px;
  font-weight: bold;
  margin-right: 2px;
}
.showOneSearchLabelNews p:nth-child(2) {
  font-size: 12px;
}

.showOneSearchTwo /deep/.van-field__control,
.showOneSearch /deep/.van-field__control {
  font-size: 16px;
  text-align: center;
}

.loadingBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(#ccc, #ccc, #ccc, 0.8);
  top: 0;
  left: 0;
}

.dNone {
  display: none !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}

.clickCss {
  animation: pulse 2s infinite;
  cursor: pointer; /* 添加指针样式表示可点击 */
  width: 18px;
}

.pinkCss {
  padding: 24px 0 10px;
  color: #ff71a6;
  font-size: 14px;
  font-family: SourceSansItalic-SemiboldItalic;
  font-style: italic;
}

.newUPI {
  padding: 20px 30px 20px;
  border-radius: 10px;
  font-size: 14px;
  background: #373737;
}
.newUPI > p {
  color: #111111;
  font-weight: 200;
  line-height: 20px;
}

.showOneSearchTwos {
  display: flex;
  /* padding: 0 16px 0 16px; */
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-size: 14px !important;
  width: 100%;
}

.showOneSearchTwos p {
  background: #eeeeee;
  height: 40px;
  line-height: 40px;
  flex: 1;
  border-radius: 6px;
  text-align: left;
  padding-left: 14px;

  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.showOneSearchTwosCopy {
  background: #ffff05;
  height: 40px;
  border-radius: 6px;
  line-height: 40px;
  display: flex;
  align-items: center;
  width: 60px;
  justify-content: center;
  margin-left: 10px;
}

.showOneSearchTwosCopy span {
  font-size: 12px;
}

.utrInput {
  display: flex;
  background: #fff;
  border: 1px solid #558cf3;
  margin: 0 15px;
  border-radius: 5px;
  line-height: 44px;
  margin-top: 46px;
  margin-bottom: 18px;
  padding-right: 6px;
}

.tabBox {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.tabBox p {
  margin-right: 10px;
  font-weight: bold;
  color: #a09da6;
}
.tabBox p::after {
  content: "";
  display: block;
  width: 80%;
  height: 2px;
  background-color: transparent;
  margin: 4px auto 0;
}
.tabBox .active::after {
  content: "";
  display: block;
  width: 80%;
  height: 1px;
  background-color: #2e79cd;
  margin: 4px auto 0;
}

.active {
  color: #2e79cd !important;
}

.payList {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.payList .payBox {
  width: 49%;
  background: #dff1fc;
}

.warn,
.warnTwo {
  display: flex;
  /* background: ##e2f2fdb9f8; */
  margin: 10px 0;
  border-radius: 10px;
  padding: 15px 20px;
  align-items: center;
}

.warn {
  background: #bce8ff;
  border: 1px solid #70b9e6;
}
.warnTwo {
  background: #e2f2fd;
  margin-bottom: 14px;
  border: 1px solid #c4dde8;
  border-radius: 10px;
}

.warn img,
.warnTwo img {
  width: 23px;
  height: 23px;
  margin-right: 12px;
}

.warn p,
.warnTwo p {
  color: #295f7b;
}

.submitUTRCss {
  background: #ffff05;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  border-radius: 10px;
  width: 60px;
  margin-left: 10px;
  font-weight: bold;
}

.txtB {
  padding: 16px 20px;
  border-radius: 10px;
  font-size: 14px;
  background: #feeac9;
  margin-top: 22px;
  display: flex;
  font-size: 12px;
  line-height: 18px;
}

.txtB p {
  color: #723a00;
  margin-left: 12px;
}
.txtB p span {
  font-weight: bold;
}
</style>
